var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOrdenes(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "21px",
    viewBox: "0 0 22 23",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 10") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Editar-producto",
    transform: "translate(-38.000000, -131.000000)",
    stroke: "currentColor",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(38.000000, 131.200010)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    x: 0.75,
    y: 0.75,
    width: 7.807692,
    height: 7.807688
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-3",
    x: 13.442383,
    y: 0.75,
    width: 7.8076935,
    height: 7.807688
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-4",
    x: 0.75,
    y: 13.442322,
    width: 7.807692,
    height: 7.807689
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-5",
    x: 13.442383,
    y: 13.442322,
    width: 7.8076935,
    height: 7.807689
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrdenes);
export default __webpack_public_path__ + "static/media/ordenes.a8b857b2ea857de79b652d42dbb2fe29.svg";
export { ForwardRef as ReactComponent };